import { Outlet } from "react-router-dom";
import { SectionView } from "../components/templates/SectionView.tsx";
import { PromptList } from "../components/organisms/PromptList.tsx";
import { MostReachedFor } from "../components/organisms/MostReachedFor.tsx";

export function PromptsPage() {
  return (
    <SectionView
      ariaLabel="Prompts"
      title="Prompts"
      sub="Copy-paste AI prompts organized by use case, tested in real work. The card shows a peek — open one for the whole thing. Copy always grabs the full text."
    >
      <MostReachedFor />
      <PromptList />
      <Outlet />
    </SectionView>
  );
}
